import "./CategorySetDialog.scss";

export default {
  name: "CategorySetDialog",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    itemCount: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: "add"
    },
    query: {
      type: String,
      default: ""
    },
    groups: {
      type: Array,
      default: () => []
    },
    pendingChanges: {
      type: Array,
      default: () => []
    },
    summaryLabel: {
      type: String,
      default: ""
    },
    canSave: {
      type: Boolean,
      default: false
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    confirmOpen: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    expandedGroupIds: {}
  }),
  watch: {
    groups: {
      immediate: true,
      deep: true,
      handler(groups) {
        const next = { ...this.expandedGroupIds };
        (groups || []).forEach(group => {
          if (next[group.id] !== undefined) {
            return;
          }
          next[group.id] = false;
        });
        this.expandedGroupIds = next;
      }
    }
  },
  computed: {
    formattedItemCount() {
      return Number(this.itemCount || 0).toLocaleString("de-DE");
    },
    confirmStats() {
      const addCount = this.pendingChanges.filter(entry => entry.type === "add")
        .length;
      const removeCount = this.pendingChanges.filter(
        entry => entry.type === "remove"
      ).length;
      return {
        addCount,
        removeCount,
        icon:
          removeCount > 0
            ? { name: "mdi-alert", color: "#f79009" }
            : { name: "mdi-help-circle-outline", color: "#0072a7" }
      };
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    handleDialogInput(isOpen) {
      if (!isOpen) {
        this.closeDialog();
      }
    },
    setMode(mode) {
      this.$emit("set-mode", mode);
    },
    setQuery(value) {
      this.$emit("set-query", value);
    },
    isExpanded(groupId) {
      if (this.query.trim()) return true;
      return this.expandedGroupIds[groupId] !== false;
    },
    toggleExpanded(groupId) {
      this.$set(this.expandedGroupIds, groupId, !this.isExpanded(groupId));
    },
    toggleEntry(entry) {
      this.$emit("toggle-entry", entry);
    },
    onGroupMainToggle(group) {
      if (!group?.selectable) {
        this.toggleExpanded(group.id);
        return;
      }
      this.toggleEntry({ tag: group.tag, title: group.title });
    },
    removePending(entry) {
      this.$emit("remove-pending", entry);
    },
    saveChanges() {
      this.$emit("open-confirm");
    },
    closeConfirm() {
      this.$emit("close-confirm");
    },
    confirmSave() {
      this.$emit("save");
    }
  }
};
